import { useLazyQuery } from '@apollo/client'
import { Button, Grow, useMediaQuery, useTheme } from '@material-ui/core'
import FilterListIcon from '@material-ui/icons/FilterList'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { ALLOCATION_LOGS } from '../../graphql/inventoryAllocateAvailability'
import {
  getEntityCode,
  getEntityId,
  getRoleFromStorage
} from '../../helpers/userData'
import { getTranslate } from '../../localization'
import inventoryPagesRoleManagement from '../../staticRoleManagement/inventoryRoleManagement'
import {
  AllocationLog,
  AllocationLogsData,
  AllocationLogsInput
} from '../../types/inventoryAllocationLogs'
import AllocationHistoryBasicFilters from './AllocationHistoryBasicFilters'
import { AllocationHistoryTable } from './AllocationHistoryTable'
import AllocationHistoryFilters from './AllocationHitoryFilters'
import useStyles from './styles/index.styles'

const AllocateHistory = () => {
  const classes = useStyles()

  const theme = useTheme()

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const [page, setpage] = useState(1)
  const [totalCount, settotalCount] = useState(0)
  const perPage = 6
  const [selectedTenant, setselectedTenant] = useState<any>()
  const [selectedAccommodation, setselectedAccommodation] = useState<any>({
    id: inventoryPagesRoleManagement
      .find((item) => item.route === '/inventory/:page')
      ?.sections?.IS_ACCOMMODATION.rolesListWithReadAccess?.includes(
        getRoleFromStorage()
      )
      ? getEntityId()
      : '',
    code: inventoryPagesRoleManagement
      .find((item) => item.route === '/inventory/:page')
      ?.sections?.IS_ACCOMMODATION.rolesListWithReadAccess?.includes(
        getRoleFromStorage()
      )
      ? getEntityCode()
      : '',
    label: '',
    value: ''
  })

  const [autoCompleteLabelRoomType, setautoCompleteLabelRoomType] =
    useState<any>({
      code: '',
      label: '',
      value: ''
    })
  const [secondaryFilterIsOpen, setsecondaryFilterIsOpen] = useState(false)
  const [allocationLogsInput, setallocationLogsInput] =
    useState<AllocationLogsInput>({
      propertyCode: '',
      showSystemChanges: false,
      page: 1,
      pageSize: perPage
    })
  const [logs, setlogs] = useState<AllocationLog[]>([])
  const [getData, { loading: loadingForLogs, refetch }] = useLazyQuery<{
    allocationLogs: AllocationLogsData
  }>(ALLOCATION_LOGS, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: ({ allocationLogs }) => {
      setlogs(allocationLogs.logs)
      settotalCount(allocationLogs.total)
    },
    onError: (err) => {
      toast.error(err.message)
    }
  })

  useEffect(() => {
    if (
      selectedTenant &&
      selectedTenant.value &&
      !(selectedAccommodation && selectedAccommodation.value)
    ) {
      getData({
        variables: {
          input: {
            ...allocationLogsInput,
            tenantId: selectedTenant.value,
            propertyCode: '',
            page: page
          }
        }
      })
    }
    if (selectedAccommodation && selectedAccommodation.value) {
      getData({
        variables: {
          input: { ...allocationLogsInput, page: page }
        }
      })
    }
  }, [selectedAccommodation, selectedTenant, page])

  return (
    <div>
      <AllocationHistoryBasicFilters
        selectedTenant={selectedTenant}
        setselectedTenant={setselectedTenant}
        setselectedAccommodation={setselectedAccommodation}
        setautoCompleteLabelRoomType={setautoCompleteLabelRoomType}
        selectedAccommodation={selectedAccommodation}
        setsecondaryFilterIsOpen={setsecondaryFilterIsOpen}
        allocationLogsInput={allocationLogsInput}
        setallocationLogsInput={setallocationLogsInput}
      />
      <div className={classes.header}>
        <Button
          size={isSmallScreen ? 'large' : 'medium'}
          startIcon={<FilterListIcon />}
          classes={{
            startIcon: isSmallScreen ? classes.startIcon : undefined
          }}
          variant="contained"
          color="primary"
          onClick={() => setsecondaryFilterIsOpen(!secondaryFilterIsOpen)}>
          {isSmallScreen ? '' : getTranslate('Filter')}
        </Button>
      </div>
      {secondaryFilterIsOpen && (
        <Grow in={secondaryFilterIsOpen}>
          <AllocationHistoryFilters
            allocationLogsInput={allocationLogsInput}
            perPage={perPage}
            setallocationLogsInput={setallocationLogsInput}
            propertyCode={selectedAccommodation.value}
            loadingForLogs={loadingForLogs}
            onFindClick={() => {
              if (selectedAccommodation && selectedAccommodation.value) {
                getData({
                  variables: {
                    input: allocationLogsInput
                  }
                })
              }
            }}
            autoCompleteLabelRoomType={autoCompleteLabelRoomType}
            setautoCompleteLabelRoomType={setautoCompleteLabelRoomType}
          />
        </Grow>
      )}
      <AllocationHistoryTable
        data={logs}
        loadingForGetBookingList={loadingForLogs}
        page={page}
        refetch={refetch}
        setPage={setpage}
        perPage={perPage}
        totalCount={totalCount}
      />
    </div>
  )
}

export default AllocateHistory
